module.exports = __webpack_public_path__ + "img/epos_loading_white.2ef58c35.gif";